module.exports = __webpack_public_path__ + "static/img/dialog_btnzh-tw.0e9b789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/dialog_btnzh-tw.png
// module id = cLhz
// module chunks = 1